<template>
	<app-page>
		<app-heading :title="isNew ? 'New City' : city.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'market-cities' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="city.name"
					required
					:errors="errors.name"
				/>
				<input-select
					label="Manager"
					:items="managers"
					v-model="city.manager"
					required
					:errors="errors.manager"
				/>
				<input-text
					type="number"
					label="# Entire rooms"
					v-model="city.entire_home"
					:errors="errors.entire_home"
				/>
				<input-text
					type="number"
					label="# Private rooms"
					v-model="city.private_room"
					:errors="errors.private_room"
				/>
				<input-text
					type="number"
					label="# Shared rooms"
					v-model="city.shared_room"
					:errors="errors.shared_room"
				/>
				<input-text
					type="number"
					label="Occupancy rate"
					v-model="city.occupancy_rate"
					:errors="errors.occupancy_rate"
				/>
				<input-text
					type="number"
					label="Booking lead time"
					v-model="city.booking_lead_time"
					:errors="errors.booking_lead_time"
				/>
				<input-text
					type="number"
					label="# Booked properties"
					v-model="city.booked_properties"
					:errors="errors.booked_properties"
				/>
				<input-text
					type="number"
					label="Revenue per available room"
					v-model="city.rev_par"
					:errors="errors.rev_par"
				/>
				<input-text
					type="number"
					label="Revenue per available room (weekend)"
					v-model="city.weekend_rev_par"
					:errors="errors.weekend_rev_par"
				/>
				<input-select
					v-model="city.best_month"
					label="Best month"
					:items="months"
					:errors="errors.best_month"
				/>
				<input-text
					label="Data providers"
					v-model="city.data_providers"
					:errors="errors.data_providers"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
import months from '@/datasources/months'

export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.city = await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('cities')
					.to(this.id)
					.get()
			}

			this.managers = await this.$ravello.graphql('marketmanagers')
				.datasource()
				.sort('name')
				.query()
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			city: {
				name: '',
				manager: null,
				entire_home: 0,
				private_room: 0,
				shared_room: 0,
				occupancy_rate: 0,
				booking_lead_time: 0,
				booked_properties: 0,
				best_month: null,
				rev_par: 0,
				weekend_rev_par: 0,
				data_providers: '',
			},
			managers: [],
			months,
			errors: {},
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
		id() {
			return this.$route.params.city
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			const request = this.$ravello.request()
				.v(2)
				.to('markets')
				.to(this.marketId)
				.to('cities')

			const payload = {
				name: this.city.name,
				manager: this.city.manager,
				entire_home: parseInt(this.city.entire_home, 10) || 0,
				private_room: parseInt(this.city.private_room, 10) || 0,
				shared_room: parseInt(this.city.shared_room, 10) || 0,
				occupancy_rate: parseInt(this.city.occupancy_rate, 10) || 0,
				booking_lead_time: parseInt(this.city.booking_lead_time, 10) || 0,
				booked_properties: parseInt(this.city.booked_properties, 10) || 0,
				best_month: this.city.best_month,
				rev_par: parseInt(this.city.rev_par, 10) || 0,
				weekend_rev_par: parseInt(this.city.weekend_rev_par, 10) || 0,
				data_providers: this.city.data_providers,
			}

			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request
						.to(this.id)
						.update(payload)
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `City successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'market-cities' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
